export class ICONS {
  public static readonly ASSETS_PATH = './assets/icons/';

  public static readonly ACCESSORIES = 'icon-accessories';
  public static readonly LINE_COMPOSITION = 'icon-line-composition';
  public static readonly LINE_SUMMARY = 'icon-line-summary';
  public static readonly PIPE_PROPERTIES = 'icon-pipe-properties';
  public static readonly SOILS = 'icon-soils';
  public static readonly GLOBAL = 'icon-global';
  public static readonly FLEXIBLE = 'icon-flexible';
  public static readonly HYBRID = 'icon-hybrid';
  public static readonly RIGID = 'icon-rigid';
  public static readonly BUOYANCY_MODULE = 'icon-buoyancy-module';
  public static readonly FLEXIBLE_PIPE = 'icon-flexible-pipe';
  public static readonly FLEX_JOINT = 'icon-flex-joint';
  public static readonly RIGID_PIPE = 'icon-rigid-pipe';
  public static readonly STRAKE = 'icon-strake';
  public static readonly STRESS_JOINT = 'icon-stress-joint';
  public static readonly STIFFENER = 'icon-stiffener';
  public static readonly CONNECTOR = 'icon-end-fitting';
  public static readonly FLOATING = 'icon-floatings';
  public static readonly CONNECTION = 'icon-connections';
  public static readonly FUNCTIONS = 'icon-functions';
  public static readonly FLUID_FUNCTION = 'icon-fluid-function';
  public static readonly RESULTS = 'icon-results';
  public static readonly WAVES = 'icon-waves';
  public static readonly CURRENTS = 'icon-currents';
  public static readonly NODAL_SUPPORT = 'icon-nodal-support';
  public static readonly ANALYSIS_CASE = 'icon-analysis-case';
  public static readonly RUN = 'icon icon-simulation';
  public static readonly POST_PROCESS = 'icon-post-processing';

  public static readonly ARROWS = {
    LEFT: '<i class="fas fa-chevron-left"></i>',
    RIGHT: '<i class="fas fa-chevron-right"></i>',
  };
}
